import andreaTheme from 'subdomains/Andrea/theme'
import benTheme from 'subdomains/Ben/theme'
import brettTheme from 'subdomains/Brett/theme'
import homeTheme from 'subdomains/Home/theme'
import veraTheme from 'subdomains/Vera/theme'

const themes = { homeTheme, brettTheme, andreaTheme, benTheme, veraTheme }

export default themes
